import { Hole, type Plate } from 'metalworks-domain'
import { useObservableEagerState } from 'observable-hooks'
import { useEffect } from 'react'

import { VerticalGroupRecipePanel, useGroupedRecipeOptions } from '@salsita-ai/platform-project-sdk/react'

import { configuratorInterface } from '../systems/configurator-interface'

interface PlateRecipesProps {
  entityId: Plate['id']
}

const recipeInstanceNames = ['boltHole', 'countersinkHole', 'cylinderHole', 'locksetHole', 'shapeHole']

// TODO do we need 100% this? It will be hard to maintain in long run - maybe some better SDK solution can be found!
export const PlateRecipes = ({ entityId }: PlateRecipesProps) => {
  const options = useGroupedRecipeOptions(entityId, recipeInstanceNames)
  const { navigationSystem, storeSystem } = configuratorInterface.useDomain()

  const selectedEntityId = useObservableEagerState(navigationSystem.selectedEntityId$)

  useEffect(() => {
    if (options.length > 0 || selectedEntityId !== entityId) {
      return
    }

    const existingFeature = storeSystem.stateSlices.committed.value.state.entities.find(entity => Hole.is(entity))
    if (!existingFeature) {
      return
    }

    const selectionUpdate = navigationSystem.getSelectUpdate(existingFeature.id)

    storeSystem.stageAndCommit([selectionUpdate])
  }, [options.length, selectedEntityId, navigationSystem, storeSystem, entityId])

  if (options.length === 0) {
    return null
  }

  return <VerticalGroupRecipePanel entityId={entityId} instanceNames={recipeInstanceNames} />
}
